import { render, staticRenderFns } from "./Categories.vue?vue&type=template&id=77e33f3e&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e33f3e",
  null
  
)

export default component.exports